import axios from 'axios';
import { store } from '../vuex/store';

const auth = axios.create({

    baseURL: process.env.VUE_APP_BASE_URL + '/api',
    // withCredentials: true,
    headers: {

        'Content-Type' : 'application/x-www-form-urlencoded',
        'AuthType'     : 'JWT',
        'ApiKey'       : process.env.VUE_APP_API_KEY
    }
});

auth.interceptors.request.use( req => {

    // console.log( 'request: ', req );
    if( store.state.isLoading == true ) return false;

    store.state.isLoading = true;
    return req;
});

auth.interceptors.response.use( config => {

    console.log( 'response: ', config );
    console.log( 'response code:: ' + config.data.responseCode + ' ::' );

    store.state.isLoading = false;
    return config;
});


export default auth;